import React from "react";
import { Link } from "react-router-dom";

import "./Start.scss";

import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

import btnMartGo from "../../images/icon/logo_menu_martgo_2x.png";
import btnLpoint from "../../images/icon/logo_menu_lpoint_2x.png";
import btnNone from "../../images/icon/logo_menu_none_2x.png";

export default class Main extends React.Component {
  render() {
    return (
      <div className="main">
        <Header isStart={true} scoMsg={"시작화면"} kioskMsg={"결제를\r\n시작하세요"} />
        <div className="body">
          <div className="body-msg">
            <p className="body-msg-1">회원이신가요?</p>
            <p className="body-msg-2">
              <span className="msg-red">적립 및 할인 방법</span>을 선택하세요.
            </p>
          </div>
          <div className="body-menu">
            <>
              <div className="btn-martgo">
                <img className="menu-icon" src={btnMartGo} alt="menu-martgo" />
                <div className="menu-txt">
                  <p className="menu-txt-header">롯데마트GO</p>
                  <p className="menu-txt-etc">(앱)</p>
                </div>
              </div>
            </>
            <>
              <div className="btn-lpoint">
                <img className="menu-icon" src={btnLpoint} alt="menu-lpoint" />
                <div className="menu-txt">
                  <p className="menu-txt-header">L.POINT</p>
                  <p className="menu-txt-etc">(앱/휴대폰번호/카드)</p>
                </div>
              </div>
            </>
            <Link to="/additem" style={{ color: "inherit", textDecoration: "inherit" }}>
              <div className="btn-none">
                <img className="menu-icon" src={btnNone} alt="menu-none" />
                <div className="menu-txt">
                  <p className="menu-txt-header">비회원</p>
                  <p className="menu-txt-etc">비회원</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="body-bottom">
            <div className="btn-start">처음으로</div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
